import styled from 'styled-components';

export const StyledVideoModal = styled.div`
  position: fixed;
  z-index: 201;

  .video-background {
    position: relative;
    width: 100vw;
    height: 100vh;
    background: black;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .video-close {
    position: absolute;
    top: 1rem;
    right: 1rem;
    cursor: pointer;

    img {
      transition: scale linear 0.2s;
    }
    img:hover {
      scale: 1.2;
    }
  }

  .video-container {
    width: calc(100vw - 2rem);
  }
`;
